import api from './api';

export interface OnboardingSetupIntentResponse {
  clientSecret: string;
  stripeCustomerId: string;
}

export interface OnboardingAttachPaymentResponse {
  subscriptionId: string;
  status: string;
  paymentMethod?: { last4?: string; brand?: string };
}

export interface OnboardingSkipBillingResponse {
  success: boolean;
  billingStatus: string;
}

class ClinicOnboardingBillingService {
  async createSetupIntent(token: string): Promise<OnboardingSetupIntentResponse> {
    const response = await api.post('/clinic-onboarding/billing/setup-intent', { token });
    return response.data.data;
  }

  async attachPaymentMethod(token: string, paymentMethodId: string): Promise<OnboardingAttachPaymentResponse> {
    const response = await api.post('/clinic-onboarding/billing/attach-payment', { token, paymentMethodId });
    return response.data.data;
  }

  async skipBilling(token: string): Promise<OnboardingSkipBillingResponse> {
    const response = await api.post('/clinic-onboarding/billing/skip', { token });
    return response.data.data;
  }

  async createStripeAccountSession(token: string): Promise<{ clientSecret: string; accountId: string }> {
    const response = await api.post<{ success: boolean; data: { clientSecret: string; accountId: string } }>(
      '/clinic-onboarding/stripe-connect/account-session',
      { token }
    );
    return response.data.data;
  }
}

export const clinicOnboardingBillingService = new ClinicOnboardingBillingService();
